export const searchPost = (post, titleFilter) => {
  return titleFilter ? post.title.search(new RegExp(titleFilter, "gi")) >= 0 : true;
};

export const filterByAuthor = (post, author) => {
  return author.length ? author.includes(post.author) : true;
};

export const filterByCategory = (post, category) => {
  return category.length ? category.includes(post.category) : true;
};
